import { testimonials } from "@/mocks/civicData";

export default function Testimonials() {
  return (
    <section className="bg-secondary-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 text-sm font-medium text-secondary-700">
              <span className="h-px w-8 bg-secondary-400"></span>
              真实故事
            </p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              身边的守望，被看见的时刻
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-7 text-foreground-600">
            这些是普通市民通过正规渠道反映身边情况的常见场景，文中均为示意化表述。
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-2xl border border-secondary-200 bg-background-50 p-7"
            >
              <i className="text-2xl text-accent-500 ri-double-quotes-l"></i>
              <blockquote className="mt-4 flex-1 text-sm leading-7 text-foreground-700">
                {t.text}
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-background-200 pt-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-200 text-secondary-800">
                  <i className="ri-user-3-line"></i>
                </span>
                <span className="text-sm font-medium text-foreground-800">{t.name}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}